// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-8b526872] {\n  padding: 24px 2rem;\n  min-height: calc(100vh - 135px);\n}\n", ""]);
// Exports
module.exports = exports;
